
function sortByColor (a, b) {
  if (a.badgeColor === b.badgeColor) return 0
  if (a.badgeColor === 'red' && b.badgeColor !== 'red') return -1
  if (a.badgeColor === 'orange' && b.badgeColor === 'blue') return -1
  if (a.badgeColor === 'orange' && b.badgeColor === 'gray') return -1
  if (a.badgeColor === 'blue' && b.badgeColor === 'gray') return -1
  return 1
}

const state = {
  blocks: []
}

const getters = {
  all: state => state.blocks
}

const actions = {
  getBlocksAndAlarms ({ commit, rootGetters }) {
    const blocks = []
    rootGetters['realEstate/blocksAlarming'].forEach(block => {
      let uncatAlarmRealEstates = []
      let totAlarms = 0

      rootGetters['realEstate/byBlockAlarming'](block).forEach(re => {
        if (re.alarmingCategories.includes('Okategoriserat')) {
          uncatAlarmRealEstates.push(re)
        }
      })
      uncatAlarmRealEstates.forEach(re => {
        re.uncatAlarms = rootGetters['alarm/byRealEstateAndCategory'](re, 'okategoriserat')
        totAlarms += re.uncatAlarms.length
        if (re.uncatAlarms.length > 0) {
          re.badgeColor = re.uncatAlarms.sort(sortByColor)[0].color
        }
      })
      let newBlock = {
        name: block,
        realEstates: uncatAlarmRealEstates.sort(sortByColor),
        totalUncatAlarms: totAlarms
      }
      blocks.push(newBlock)
    })
    let allRealEstates = []
    let totalAlarmsAllRealEstates = 0
    blocks.forEach(block => {
      block.realEstates.forEach(re => {
        allRealEstates.push(re)
      })
      totalAlarmsAllRealEstates += block.totalUncatAlarms
    })
    let allBlocks = {
      name: 'Alla',
      realEstates: allRealEstates.sort(sortByColor),
      totalUncatAlarms: totalAlarmsAllRealEstates
    }
    blocks.unshift(allBlocks)
    commit('setBlocksWithUncategorisedAlarms', blocks)
  }
}

const mutations = {
  setBlocksWithUncategorisedAlarms (state, blocks) {
    state.blocks = blocks
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/blocks.js